import { render, staticRenderFns } from "./BuildUpdate.vue?vue&type=template&id=328c87c5&scoped=true&"
import script from "./BuildUpdate.vue?vue&type=script&lang=js&"
export * from "./BuildUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c87c5",
  null
  
)

export default component.exports